<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="4">
          <b-form-group v-b-tooltip.hover title="Password Fail Count Threshold, default is 5 on system">
            <label for="ph_lock_count">Password failed Count</label>
            <b-input type="number" v-model="group.security_policy.account_lock_count" :disabled="lock || true"></b-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group v-b-tooltip.hover title="when failed too many logins, default is 5 min on system">
            <label for="ph_lock_time">Block time(Min)</label>
            <b-input type="number" v-model="group.security_policy.account_lock_time" :disabled="lock || true"></b-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group v-b-tooltip.hover title="require min length">
            <label for="ph_password_min_len">Password Min length</label>
            <b-input type="number" v-model="group.security_policy.password_min_len" :disabled="lock || true"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="4">
          <b-form-group label="Password Use Alphabet" label-for="ph_password_use_alphabet" v-b-tooltip.hover title="password require alphabet, ex) abcdef....">
            <c-switch color="info" label size="sm" v-model="group.security_policy.password_use_alphabet" :disabled="lock || true" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Password Use Spacial" label-for="ph_password_use_number" v-b-tooltip.hover title="password require Spacial, ex) !@#$%&*()_+-=">
            <c-switch color="info" label size="sm" v-model="group.security_policy.password_use_number" :disabled="lock || true" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Password Use Number" label-for="ph_password_use_spacial" v-b-tooltip.hover title="password require Number, ex) 0123456789">
            <c-switch color="info" label size="sm" v-model="group.security_policy.password_use_spacial" :disabled="lock || true" />
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="12">
          * Allow IP : The settings in the group apply to all accounts in the group
        </b-col>
      </b-row>
      <hr>
        <ip-list
          type="account"
          comment="The IP Access Control Policy of the Group comes first, followed by the User-specific IP Access Control Policy."
          :lock="lock || true"
          :press="false"
          :show_button="false"
          :ip_list="group.allow_ip_account || []"
          :edit="false"
          >
          <!-- @add="ip_add"
          @save="save"
          @remove="ip_remove"
          @clear="ip_clear" -->
        </ip-list>
      <hr>
        <ip-list
          type="agent"
          comment="IP access control is applied when the agent is installed If you don't have one, you can install it anywhere, but we recommend it."
          :lock="lock || true"
          :press="false"
          :show_button="false"
          :edit="false"
          :ip_list="group.allow_ip_agent || []"
          >
        </ip-list>
        <!-- @add="ip_add"
        @save="save"
        @remove="ip_remove"
        @clear="ip_clear" -->
      <hr>
      <!-- <template v-if="lock">
        <template>
          <b-button size="sm" variant="primary" @click="edit"> Modify </b-button>
        </template>
      </template>
      <template v-else>
        <b-button size="sm" variant="success" @click="save"> Save </b-button>
        <b-button size="sm" variant="default" @click="cancel"> Cancel </b-button>
      </template> -->
    </b-card>
  </div>
</template>

<script>
import ipList from './ipList';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  name : "policy",
  props : ["lock", "group"],
  components: { ipList, cSwitch },
  data : () => {
    return {
      model : {
        security_policy : {
        account_lock_count : 5,
        account_lock_time : 5,
        password_min_len : 10,
        password_use_spacial : true,
        password_use_alphabet : true,
        password_use_number : true,
      },
      allow_ip_agent : [],
      allow_ip_account : []
      }
    }
  },
  computed: {
  },
  methods: {
    edit: function() { this.emit('edit') },
    save: function() { this.emit('save') },
    cancel: function() { this.emit('cancel') },
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('group.security_policy.vue', 'created'); },
  destroyed: function() { console.log('group.security_policy.vue', 'destroyed'); },
  mounted: function() {
    console.log('group.security_policy.vue', 'mounted');
  },
}
</script>
